import axios from 'axios';
import { BASEURL } from 'enviroments/enviroments';

interface Credentials {
  userN: string;
  userC: string;
  saveUser: boolean;
}

const api = axios.create({
  baseURL: BASEURL,
});

const auth = {
  login: async (credentials: Credentials): Promise<any> => {
    const { userN , userC, saveUser } = credentials;
    try {
      const resp: any = await api.post(`${BASEURL}/Login`, {
        _nombre: userN,
        _clave: userC
      });
      const userData = { ...resp.data };
      localStorage.setItem('spUsInv', JSON.stringify(userData.response));
      localStorage.setItem('arrC', JSON.stringify(userData.response?.array_clients));
      // Store the expiration time
      const expireTime = new Date(userData.response?.claims?._expireToken).getTime();
      localStorage.setItem('expireTime', expireTime.toString());

      return resp.data;
    } catch (error: any) {
      if (error.response) {
        throw {message: error.response.data};
      } 
      throw error;
    }
  },

  recovery: async (credentials: Credentials): Promise<any> => {
    const { userN } = credentials;
    try {
      const resp: any = await api.post(`${BASEURL}/RecuperarClaveUsuario/${userN}`);
      const userData = { ...resp.data };
      console.log('resp', resp)

      return resp.data;
    } catch (error: any) {
      if (error.response) {
        throw {message: error.response.data};
      } 
      throw error;
    }
  },

  logout: (): Boolean => {
    localStorage.removeItem('user');
    localStorage.removeItem('originalPath');
    localStorage.removeItem('expireTime');
    localStorage.removeItem('arrC');
    localStorage.removeItem('spUsInv');
    localStorage.removeItem('cliCod');
    return !localStorage.getItem('user') && !localStorage.getItem('originalPath');
  },

  checkAuthorization: (allowedRoles: string[]) => {
    const userRole = localStorage.getItem('userRole') || '';
    return allowedRoles.includes(userRole);
  }
};

export default auth;